import type { AuthSlice } from 'app/auth/types';
import type { CollabSlice } from 'app/collab/types';
import { connect } from 'react-redux';
import { getUserId } from '../../../auth/selectors';
import { getEditingUser, getViewingUsers } from '../../selectors';
import {
  ContentItemCollab,
  type ContentItemCollabOwnProps,
  type ContentItemCollabStateProps
} from './content-item-collab';

export const mapStateToProps = (
  state: AuthSlice & CollabSlice,
  props: ContentItemCollabOwnProps
): ContentItemCollabStateProps => {
  const editingUser = getEditingUser(state, props);
  const viewingUsers = getViewingUsers(state, props).filter((user) => user.id !== editingUser?.id);
  return {
    editingUser,
    viewingUsers,
    currentUserId: getUserId(state)
  };
};

export default connect(mapStateToProps)(ContentItemCollab);
